import Vue from 'vue';

import UserWindowSizeUtility from '@/classes/common/UserWindowSizeUtility';



/** 通常背景色 */
const BG_COLOR = 'rgba(234, 234, 234, 1)';

/** フォーカス背景色 */
const FOCUS_COLOR = 'rgba(192, 255, 192, 1)';

/** 筆跡色 */
const PEN_COLOR = 'rgba(85, 85, 85, 1)';

export default Vue.extend({

  name: 'Calc2Confirm',

  props: {
    char: {
      type: String,
      default: ''
    },
    isFocus: {
      type: Boolean,
      default: false
    },
    vinculumFlg: {
      type: Boolean,
      default: false
    },
    denomFlg: {
      type: Boolean,
      default: false
    },
    numerFlg: {
      type: Boolean,
      default: false
    },
    rootFlg: {
      type: Boolean,
      default: false
    },
    bracketsFlg: {
      type: Boolean,
      default: false
    },
    upperFlg: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    canvas(): HTMLCanvasElement {
      const canvas = this.$refs.canvas;
      if (canvas === undefined) throw new Error('canvas未初期化');
      return canvas as HTMLCanvasElement;
    },
    canvasContext(): CanvasRenderingContext2D {
      const context = this.canvas.getContext('2d');
      if (context === null) throw new Error('context未初期化');
      return context;
    },
  },

  mounted(): void {
    this.$_setCanvasSize();
  },

  methods: {
    focus(): void {
      this.$emit('onClick');
    },
    onChangeWindowSizeHandler(): void {
      this.$_setCanvasSize();
    },
    $_setCanvasSize(): void {
      this.canvas.width = this.canvas.clientWidth;
      this.canvas.height = this.canvas.clientHeight;
      this.$_draw();
    },
    $_draw(): void {
      const context = this.canvasContext;

      // 塗りつぶし
      if (this.isFocus) context.fillStyle = FOCUS_COLOR;
      else              context.fillStyle = BG_COLOR;
      context.fillRect(0, 0, this.canvas.width, this.canvas.height);

      // ルート描画
      if (this.char === '√') {
        context.lineWidth = UserWindowSizeUtility.penSize();
        context.strokeStyle = PEN_COLOR;
        context.beginPath();
        context.moveTo(UserWindowSizeUtility.calculateRatio(14), UserWindowSizeUtility.calculateRatio(25));
        context.lineTo(UserWindowSizeUtility.calculateRatio(17), UserWindowSizeUtility.calculateRatio(22));
        context.lineTo(UserWindowSizeUtility.calculateRatio(20), UserWindowSizeUtility.calculateRatio(27));
        context.lineTo(UserWindowSizeUtility.calculateRatio(32), UserWindowSizeUtility.calculateRatio(1));
        context.stroke();
        context.closePath();
        return; // ルートのマスは他に描画しない
      }

      // ルートの上線
      if (this.rootFlg) {
        context.lineWidth = UserWindowSizeUtility.penSize();
        context.strokeStyle = PEN_COLOR;
        context.beginPath();
        context.moveTo(0,                                        UserWindowSizeUtility.calculateRatio(2));
        context.lineTo(UserWindowSizeUtility.calculateRatio(32), UserWindowSizeUtility.calculateRatio(2));
        context.stroke();
        context.closePath();
      }

      // 文字描画
      if (this.char !== '') {
        let char = this.char;
        if      (char === '+') char = '＋';
        else if (char === '-') char = '－';
        context.font = this.upperFlg ? UserWindowSizeUtility.canvasConfirmExponentsFont() : UserWindowSizeUtility.canvasConfirmFont();
        const textMetrics = context.measureText(char);
        const tw = textMetrics.width;
        const dy = this.upperFlg ? -1 * UserWindowSizeUtility.calculateRatio(2) : UserWindowSizeUtility.calculateRatio(10);
        const x = (this.canvas.width - tw) / 2;
        const y = this.canvas.height / 2 + dy;
        context.fillStyle = PEN_COLOR;
        context.fillText(char, x, y);
      }
    }
  },

  watch: {
    char(): void {
      this.$_draw();
    },
    isFocus(): void {
      this.$_draw();
    },
    upperFlg(): void {
      this.$_draw();
    }
  }

});
